
import React, { useEffect } from 'react'

function Booking() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleWhatsAppInquiry = (e) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);

    const name = formData.get('name')?.toString().trim();
    const email = formData.get('email')?.toString().trim();
    const dateTime = formData.get('datetime')?.toString().trim();
    const destination = formData.get('destination')?.toString().trim();
    const specialRequest = formData.get('message')?.toString().trim();

    const message = `Hello Opulent Tours! I would like to plan a tour.

Name: ${name}
Email: ${email}
Date & Time: ${dateTime}
Destination: ${destination}
Special Request: ${specialRequest || 'Not specified'}`;

    const whatsappURL = `https://wa.me/94742343484?text=${encodeURIComponent(message)}`;

    window.open(whatsappURL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div>
      <div
        className="container-fluid bg-primary py-5 mb-5 hero-header"
        style={{
          backgroundImage: 'linear-gradient(rgba(20, 20, 31, 0.35), rgba(20, 20, 31, 0.45)), url("assets/img/bookingheaderr.jpg")',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          minHeight: '95vh',
          paddingTop: '8rem',
          paddingBottom: '8rem',
          imageRendering: 'crisp-edges',
          WebkitImageRendering: 'crisp-edges',
          transform: 'translateZ(0)',
          backfaceVisibility: 'hidden'
        }}
      >
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1
                className="animated slideInDown"
                style={{
                  fontFamily: 'Georgia, "Times New Roman", serif',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  fontSize: '5rem',
                  lineHeight: '1.3',
                  color: '#f5f0e8',
                  textShadow: '2px 2px 8px rgba(0,0,0,0.6)'
                }}
              >
                Your Adventure awaits, Book with confidence
              </h1>

              <p
                className="animated slideInDown"
                style={{
                  fontFamily: 'Georgia, "Times New Roman", serif',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  fontSize: '2rem',
                  lineHeight: '1.3',
                  color: '#f5f0e8',
                  textShadow: '2px 2px 8px rgba(0,0,0,0.6)',
                  marginTop: '1rem'
                }}
              >
                Book smart. Travel happy
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Process Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div
            className="text-center pb-4 wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <h6 className="section-title bg-white text-center text-primary px-3">
              Process
            </h6>

            <h1 className="mb-5" style={{ color: '#000000' }}>
              3 Easy Steps
            </h1>
          </div>

          <div className="row gy-5 gx-4 justify-content-center">
            <div
              className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="position-relative border border-primary pt-5 pb-4 px-4">
                <div
                  className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                  style={{ width: 100, height: 100 }}
                >
                  <i className="fa fa-globe fa-3x text-white" />
                </div>

                <h5
                  className="mt-4"
                  style={{
                    fontSize: '1.35rem',
                    lineHeight: '1.8',
                    color: '#000000'
                  }}
                >
                  Choose A Destination
                </h5>

                <hr className="w-25 mx-auto bg-primary mb-1" />
                <hr className="w-50 mx-auto bg-primary mt-0" />

                <p
                  className="mb-0"
                  style={{
                    fontSize: '1.15rem',
                    lineHeight: '1.8',
                    color: '#000000'
                  }}
                >
                  Select from our curated destinations across Sri Lanka, or let us create a custom itinerary just for you
                </p>
              </div>
            </div>

            <div
              className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
              data-wow-delay="0.3s"
            >
              <div className="position-relative border border-primary pt-5 pb-4 px-4">
                <div
                  className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                  style={{ width: 100, height: 100 }}
                >
                  <i className="fa fa-dollar-sign fa-3x text-white" />
                </div>

                <h5
                  className="mt-4"
                  style={{
                    fontSize: '1.35rem',
                    lineHeight: '1.8',
                    color: '#000000'
                  }}
                >
                  Confirm &amp; Pay
                </h5>

                <hr className="w-25 mx-auto bg-primary mb-1" />
                <hr className="w-50 mx-auto bg-primary mt-0" />

                <p
                  className="mb-0"
                  style={{
                    fontSize: '1.15rem',
                    lineHeight: '1.8',
                    color: '#000000'
                  }}
                >
                  Review your personalized tour package and complete your booking with our secure payment options
                </p>
              </div>
            </div>

            <div
              className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="position-relative border border-primary pt-5 pb-4 px-4">
                <div
                  className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                  style={{ width: 100, height: 100 }}
                >
                  <i className="fa fa-plane fa-3x text-white" />
                </div>

                <h5
                  className="mt-4"
                  style={{
                    fontSize: '1.35rem',
                    lineHeight: '1.8',
                    color: '#000000'
                  }}
                >
                  Start Your Journey
                </h5>

                <hr className="w-25 mx-auto bg-primary mb-1" />
                <hr className="w-50 mx-auto bg-primary mt-0" />

                <p
                  className="mb-0"
                  style={{
                    fontSize: '1.15rem',
                    lineHeight: '1.8',
                    color: '#000000'
                  }}
                >
                  Pack your bags and get ready for an unforgettable adventure with 24/7 support throughout your journey
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Process End */}

      {/* Booking Start */}
      <div
        className="container-xxl py-5 wow fadeInUp"
        data-wow-delay="0.1s"
      >
        <div className="container">
          <div className="booking p-5">
            <div className="row g-5 align-items-center">
              <div className="col-md-6 text-white">
                <h1 className="text-white mb-4">
                  Customize / Plan your Dream Trip
                </h1>

                <p className="mb-4">
                  You can customize our recommended tours or plan your dream trip by discussing your preferences with the friendly team at Opulent Tours.
                </p>

                <a
                  className="btn btn-outline-light py-3 px-5 mt-2"
                  href="/contact"
                >
                  Read More
                </a>
              </div>

              <div className="col-md-6">
                <h1 className="text-white mb-4">Plan A Tour</h1>

                <form onSubmit={handleWhatsAppInquiry}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control bg-transparent"
                          id="name"
                          name="name"
                          placeholder="Your Name"
                          required
                        />
                        <label htmlFor="name">Your Name</label>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="email"
                          className="form-control bg-transparent"
                          id="email"
                          name="email"
                          placeholder="Your Email"
                          required
                        />
                        <label htmlFor="email">Your Email</label>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="datetime-local"
                          className="form-control bg-transparent"
                          id="datetime"
                          name="datetime"
                          placeholder="Date & Time"
                          min={new Date().toISOString().slice(0, 16)}
                          required
                        />
                        <label htmlFor="datetime">Date &amp; Time</label>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating">
                        <select
                          className="form-select bg-transparent"
                          id="select1"
                          name="destination"
                          defaultValue="Sri Lanka"
                          required
                        >
                          <option value="Sri Lanka">Sri Lanka</option>
                        </select>

                        <label htmlFor="select1">Destination</label>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-floating">
                        <textarea
                          className="form-control bg-transparent"
                          placeholder="Special Request"
                          id="message"
                          name="message"
                          style={{ height: 100 }}
                          defaultValue=""
                        />

                        <label htmlFor="message">Special Request</label>
                      </div>
                    </div>

                    <div className="col-12">
                      <button
                        className="btn btn-outline-light w-100 py-3"
                        type="submit"
                      >
                        Inquire Now
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Booking End */}
    </div>
  )
}

export default Booking
